const healthChangesInteres = [
    "Muy interesado",
    "Interesado",
    "Poco interesado",
    "Sin interés",
   
  ];
  
  export default healthChangesInteres;
  